<template>
  <v-row>
    <v-col class="fw-bold">
      {{i18n.global.t('pages.firmwareBulkUpdate.firmwareVirsion.name')}}
      <span style="color: red">✴︎</span>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <FirmwareVersionAutoComplete
        v-model="firmware"
        :initialItemId="props.initialItemId"
        :errorMessages="props.errorMessages"
      />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import i18n from '@/lang/i18n';
import FirmwareVersionAutoComplete from '@/components/AutoCompletes/FirmwareVersionAutoComplete.vue';
import FirmwareVersionsType from '@/types/FirmwareVersionsType';

const emit = defineEmits(['update:modelValue']);
const props = defineProps<{
  modelValue: FirmwareVersionsType | undefined
  initialItemId?: number
  errorMessages?: string[]
}>()

const firmware = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
})

</script>
